import React, {useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import FormContainer from './Forms/FormContainer';
import FormInput from './Forms/FormInput';
import {useNeuroMessages} from './MessageContext';
import {createRemoteSession, useDispatch} from '../state';
import NeuroMessage from './NeuroMessage';
import {useUser} from '../hooks/useUser';

const RemoteSessionForm = ({ className, initialValue = null, onSubmit, customMessagesObj={} }) => {
  const appDispatch = useDispatch();
  const formId = 'remoteSession';
  const messageContext = useNeuroMessages();
  const { uuid, getBranch, getEmployee } = useUser();
  const classes = classnames(className, 'socialForm', 'remoteSessionForm');
  const [emailAddress, setEmailAddress] = useState(initialValue);

  const onFormChange = ({ emailAddress }) => {
    setEmailAddress(emailAddress);
  };

  const getMessagesForNewSession = () => {
    //TODO: document how to format remote banker session message
    const msgId = 'remoteSession.onCreateMsg';
    const { firstName: employeeFirstName, lastName: employeeLastName, nmlsId, email: employeeEmail, phone: employeePhone} = getEmployee();
    const { name: branchName } = getBranch();
    const htmlMessageValues = { employeeFirstName, employeeLastName, employeeEmail, employeePhone, nmlsId, branchName, uuid };
    const grabMessage = key => messageContext.hasMessage(`${msgId}.${key}`) ? messageContext.formatIntlMessage({id: `${msgId}.${key}`}, htmlMessageValues) : '';
    return {
      bankerMessage: grabMessage('bankerMessage'),
      bankerSubject: grabMessage('bankerSubject'),
      customerMessage: grabMessage('customerMessage'),
      customerSubject: grabMessage('customerSubject'),
      ...customMessagesObj
    };
  };

  const onFormSubmit = () => {
    appDispatch(createRemoteSession({ emailAddress, messagesObj: getMessagesForNewSession() }));
    onSubmit && onSubmit();
  };

  return (
    <section className={classes}>
      <NeuroMessage id="remoteSession.formBody" tagName="p" />
      <FormContainer
        onChange={onFormChange}
        onSubmit={onFormSubmit}
        formId={formId}
        renderDefaultSubmit={true}
      >
        <FormInput
          formId={formId}
          initialValue={initialValue}
          name="emailAddress"
          required={true}
          validations="isEmail"
          validationError={messageContext.getMessage(
            'formInput.validationError.isEmail'
          )}
        />
      </FormContainer>
    </section>
  );
};
RemoteSessionForm.propTypes = {
  className: PropTypes.string,
  customMessagesObj: PropTypes.object,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default RemoteSessionForm;
